<template>
    <div class="headermenu">
        <div class="py-0 px-0 hm4-inner">
           <div class="menubar">
                <!-- 로고 (데스크톱 전용) -->
                <router-link :to="currentUserShopSlug ? '/' + currentUserShopSlug : { name: 'Home' }" class="hm-logo">
                    <template v-if="currentCategoryImage">
                        <img :src="currentCategoryImage" :alt="currentCategoryName" class="hm-logo__cat" />
                    </template>
                    <template v-else-if="shopLogo">
                        <img :src="shopLogo" :alt="appName" class="hm-logo__img" />
                    </template>
                    <template v-else>
                        <img src="/assets/img/header/header-bi.svg" :alt="appName" class="hm-logo__bi" />
                        <img src="/assets/img/header/header-logo.svg" :alt="appName" class="hm-logo__img" />
                    </template>
                </router-link>

                <div v-if="shopUseTopMenu" class="d-flex">
                    <v-list class="d-flex ma-0 pa-0">
                        <v-list-item class="flex-grow-0 flex-fill category ma-0 me-5 pa-0">
                            <v-list-item-title @click="showFullCategories" class="mt-1 pointer">
                                <i class="las fs-29" :class="isFullCategories ? 'la-times' : 'la-bars'"></i>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-for="(item, i) in menuItems" :key="i" class="flex-grow-0 flex-fill">
                            <v-list-item-title>
                                <dynamic-link
                                    :to="item.href || (item.children && item.children[0] && item.children[0].href) || '/'"
                                    :append-class="{ 'text-reset fw-700': $route.path === item.href, 'text-reset fw-500': $route.path !== item.href }"
                                >
                                    <div class="px-2 py-5 me-1 position-relative" @mouseenter="viewSubMenu(i, 'inactive')" @mouseleave="hideSubMenu(i)">
                                        <font :color="item.colors">
                                            <div class="icon-floating" v-if="item.icon && !isBadgeIcon(item.icon)">
                                                <i class="las lh-1 fs-20" :class="item.icon"></i>
                                            </div>
                                            <div class="fs-16 nav-item-label" v-if="item.children && item.children.length">
                                                {{ item.name }}
                                                <span v-if="item.icon === 'badge-new'" class="nav-badge nav-badge--new">NEW</span>
                                                <span v-if="item.icon === 'badge-sale'" class="nav-badge nav-badge--sale">SALE</span>
                                                <span v-if="item.icon === 'badge-hot'" class="nav-badge nav-badge--hot">HOT</span>
                                            </div>
                                            <div class="fs-16 nav-item-label" @mouseenter="hideAllSubMenu()" v-else>
                                                {{ item.name }}
                                                <span v-if="item.icon === 'badge-new'" class="nav-badge nav-badge--new">NEW</span>
                                                <span v-if="item.icon === 'badge-sale'" class="nav-badge nav-badge--sale">SALE</span>
                                                <span v-if="item.icon === 'badge-hot'" class="nav-badge nav-badge--hot">HOT</span>
                                            </div>
                                        </font>
                                    </div>
                                </dynamic-link>
                                <div
                                    class="sub_menus"
                                    v-bind:ref="'sub_menu' + i"
                                    v-on:mouseenter="viewSubMenu(i)"
                                    v-on:mouseleave="hideSubMenu(i)"
                                    v-if="item.children && item.children.length"
                                >
                                    <div class="sub-wrapper">
                                        <div class="container cstm-row">
                                            <div class="sub-list">
                                                <div class="sub-columns">
                                                    <div
                                                        v-for="(sub_menu, j) in item.children"
                                                        :key="i + '_' + j"
                                                        class="sub-col"
                                                    >
                                                        <!-- 2차: 3차 자식이 있으면 컬럼 헤더 스타일 -->
                                                        <div v-if="sub_menu.children && sub_menu.children.length" class="sub-col-header">
                                                            <dynamic-link :to="sub_menu.href || (sub_menu.children[0] && sub_menu.children[0].href) || '/'">
                                                                {{ sub_menu.name }}<span class="sub-col-arrow"> ›</span>
                                                            </dynamic-link>
                                                        </div>
                                                        <!-- 2차: 3차 자식 없으면 일반 링크 -->
                                                        <div v-else class="sub-col-link">
                                                            <dynamic-link :to="sub_menu.href || '/'">{{ sub_menu.name }}</dynamic-link>
                                                        </div>
                                                        <!-- 3차 목록 -->
                                                        <ul v-if="sub_menu.children && sub_menu.children.length">
                                                            <li v-for="(sub_menu2, k) in sub_menu.children" :key="i + '_' + j + '_' + k">
                                                                <!-- 3차: 4차 자식이 있으면 소그룹 헤더 -->
                                                                <template v-if="sub_menu2.children && sub_menu2.children.length">
                                                                    <dynamic-link :to="sub_menu2.href || '/'" class="sub-list-link2 sub-list-link2--group">
                                                                        {{ sub_menu2.name }}
                                                                    </dynamic-link>
                                                                    <ul class="sub-list-depth4">
                                                                        <li v-for="(sub_menu3, l) in sub_menu2.children" :key="i + '_' + j + '_' + k + '_' + l">
                                                                            <dynamic-link :to="sub_menu3.href || '/'" class="sub-list-link3">
                                                                                {{ sub_menu3.name }}
                                                                                <span v-if="sub_menu3.icon === 'badge-hot'" class="badge-hot-tag">🔥HOT</span>
                                                                            </dynamic-link>
                                                                        </li>
                                                                    </ul>
                                                                </template>
                                                                <!-- 3차: 자식 없으면 일반 링크 (기존 동작 유지) -->
                                                                <template v-else>
                                                                    <dynamic-link :to="sub_menu2.href || '/'" class="sub-list-link2">
                                                                        {{ sub_menu2.name }}
                                                                        <span v-if="sub_menu2.icon === 'badge-hot'" class="badge-hot-tag">🔥HOT</span>
                                                                    </dynamic-link>
                                                                </template>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="right-side">
                                                <div>
                                                    <p>
                                                        환경친화적 인쇄를 지향하는
                                                        <br />
                                                        인쇄의 넘버원,
                                                        <strong>프리원!</strong>
                                                    </p>
                                                    <img src="/assets/img/soyinkmark.svg" alt="인증마크" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </div>
                <div class="d-flex align-center right-icons">
                    <div v-if="!isAuthenticated" class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="shopSlugForLogin ? { name: 'Login', query: { shop_id: shopSlugForLogin } } : { name: 'Login', query: {} }" class="text-reset">
                                    <i v-bind="attrs" v-on="on" class="las la-sign-in-alt"></i>
                                </router-link>
                            </template>
                            <span>로그인</span>
                        </v-tooltip>
                    </div>
                    <template v-else>
                        <div class="user-info-bar">
                            <span class="user-name">{{ currentUser.name }}</span><span v-if="currentUserCompany.company_name" class="user-company">({{ currentUserCompany.company_name }})</span>
                        </div>  
                    </template>
                    <div v-if="isUseAfterLogin" class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <a :href="homeHref" class="text-reset">
                                    <i v-bind="attrs" v-on="on" class="las la-home"></i>
                                </a>
                            </template>
                            <span>홈</span>
                        </v-tooltip>
                    </div>
                    <div v-for="(menu, i) in $optional('data.logobar_menu?.labels')" :key="i" class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="$optional('data.logobar_menu.links')[i]" class="text-reset">
                                    <i class="las" v-bind="attrs" v-on="on" v-bind:class="$optional('data.logobar_menu.icons')[i]">
                                        <v-badge
                                            color="error"
                                            :content="getCartCount"
                                            inline
                                            v-if="getCartCount > 0 && $optional('data.logobar_menu.links')[i] === '/cart'"
                                            class="icon-badge"
                                            style="left: 950px; top: -12px"
                                        ></v-badge>
                                    </i>
                                </router-link>
                            </template>
                            <span>{{ menu }}</span>
                        </v-tooltip>
                    </div>
                      <div class="icon-item">
                            <v-tooltip attach bottom transition="slide-y-transition">
                                <template v-slot:activator="{ on, attrs }">
                                    <router-link :to="{ name: 'Logout' }" class="text-reset">
                                        <i v-bind="attrs" v-on="on" class="las la-sign-out-alt"></i>
                                    </router-link>
                                </template>
                                <span>로그아웃</span>
                            </v-tooltip>
                        </div>
                   
                </div>
            </div>
            <FullCategories :show="isFullCategories" ref="fullCategories" @close="closeFullCategories" />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    //import FullCategories from "./FullCategories.vue";
    import FullCategories from '../../../pages/custom/prione/FullCategories.vue';

    export default {
        props: {
            loading: { type: Boolean, required: true, default: true },
            data: {
                type: Object,
                default: {},
                current_path: '',
            },
        },
        watch: {
            // $route 객체를 감시하여 경로가 변경되었는지 확인
            $route(to, from) {
                //console.log('Route changed from', from.path, 'to', to.path);
                this.isFullCategories = false;
            },
        },
        data: () => ({
            isFullCategories: false,
        }),
        computed: {
            ...mapGetters('cart', ['getCartCount']),
            ...mapGetters('auth', ['isAuthenticated', 'currentUser', 'currentUserCompany', 'currentUserShopSlug', 'isUseAfterLogin', 'shopUseTopMenu']),
            ...mapGetters('app', ['demoMode', 'appName', 'currentCategoryImage', 'currentCategoryName']),
            shopSlugForLogin() {
                if (this.$route.params.slug) return this.$route.params.slug;
                if (this.$route.query.shop_id) return this.$route.query.shop_id;
                const redirect = this.$route.query.redirect || '';
                return redirect.split('/').filter(Boolean)[0] || null;
            },
            // 거래처(shop_id)별 상단메뉴(메인/2차/3차옵션). setting/header API 응답(props.data.menu_items)에서 옴.
            // storage/docs/26-06-25-02-02-관리자-메인메뉴분리-Plan.md
            menuItems() {
                return (this.data && this.data.menu_items) || [];
            },
            shopLogo() {
                return (this.data && (this.data.shop_logo || this.data.home_shop_logo)) || '';
            },
            homeHref() {
                return this.isUseAfterLogin ? '/after-login/' : '/mypage/dashboard';
            },
        },
        components: {
            FullCategories,
        },
        methods: {
            isBadgeIcon(icon) {
                return ['badge-new', 'badge-sale', 'badge-hot'].includes(icon);
            },
            showFullCategories() {
                this.isFullCategories = !this.isFullCategories;
                // this.hideAllSubMenu();
            },
            closeFullCategories() {
                this.isFullCategories = false;
                // this.hideAllSubMenu();
            },
            viewSubMenu(i, inactive) {
                if (inactive === 'inactive') {
                    const targetMenu = document.querySelector('.active2');
                    if (targetMenu) targetMenu.classList.remove('active2');
                }

                const menuRef = 'sub_menu' + i;
                if (!this.$refs[menuRef]) return;
                const element = this.$refs[menuRef][0];

                const subMenus = document.querySelectorAll('.sub_menus');
                subMenus.forEach((menu) => {
                    menu.classList.remove('active');
                    // menu.style.display = 'none';
                });

                element.classList.add('active');
                // element.style.display = 'block';

                this.closeFullCategories();
            },
            hideSubMenu(i) {
                const menuRef = 'sub_menu' + i;
                if (!this.$refs[menuRef]) return;
                const element = this.$refs[menuRef][0];
                // element.style.display = 'none';
                element.classList.remove('active');

                this.closeFullCategories();
            },
            hideAllSubMenu() {
                const subMenus = document.querySelectorAll('.sub_menus');
                subMenus.forEach((menu) => {
                    // menu.style.display = 'none';
                    menu.classList.remove('active');
                });

                this.closeFullCategories();
            },
            showMenu(e, c) {
                if (!c || !c.length) {
                    const activeMenu = document.querySelector('.active2');
                    if (activeMenu) activeMenu.classList.remove('active2');
                } else {
                    e.currentTarget.classList.add('active2');
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    /* 전역 .v-application .container { margin-top: 150px } override */
    .container {
        margin-top: 0 !important;
    }
    .hm4-inner {
        width: 100%;
        max-width: var(--container-max-width, 1280px);
        margin-left: auto;
        margin-right: auto;
    }

    .cstm-row {
        display: flex;
    }

    ::v-deep .sub_menus {
        position: absolute;
        left: 0;
        right: 0;
        top: 40px;
        z-index: 1001;
        padding-top: 24px;
        box-shadow: 0px 20px 30px -40px rgb(0 0 0 / 40%);
        transform: scale(0);
        opacity: 0;
        transition:
            opacity 0.5s,
            margin 0.5s,
            transform 0s 0.5s;
        pointer-events: none;

        &.active {
            transform: scale(1);
            margin-top: 0;
            opacity: 1;
            pointer-events: all;

            transition:
                opacity 0.5s,
                margin 0.5s;
        }

        .sub-list {
            h4 {
                margin-bottom: 12px;
            }
        }
    }
    ::v-deep .sub-wrapper {
        border-top: 1px solid #dddddd;
        position: relative;
        box-shadow: 0 -1px 1px #fff;
        padding: 20px 0 60px;

        background-color: #ffffff;

        & > div {
            justify-content: space-between;
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        .sub-list {
            flex: 1;
            min-width: 0;

            .sub-columns {
                display: flex;
                flex-wrap: wrap;
                gap: 0;
            }

            .sub-col {
                min-width: 150px;
                padding-right: 24px;
                margin-right: 0;
                border-right: 1px solid #e5e5e5;
                padding-left: 0;

                &:first-child {
                    padding-left: 0;
                }

                &:last-child {
                    border-right: none;
                }

                & + .sub-col {
                    padding-left: 24px;
                }
            }

            .sub-col-header {
                margin-bottom: 14px;

                a {
                    font-size: 15px;
                    font-weight: 600;
                    color: #111;
                    line-height: 1.3;
                    text-decoration: none;

                    &:hover {
                        color: #1a1a1a;
                    }

                    .sub-col-arrow {
                        font-size: 13px;
                        font-weight: 400;
                        color: #555;
                    }
                }
            }

            .sub-col-link {
                margin-bottom: 14px;

                a {
                    font-size: 15px;
                    font-weight: 600;
                    color: #111;
                    text-decoration: none;
                }
            }

            ul {
                margin: 0;
                padding: 0;
                list-style: none;

                li {
                    margin-bottom: 10px;

                    .sub-list-link2 > a {
                        font-size: 13px;
                        line-height: 1.4;
                        color: #444;
                        position: relative;
                        text-decoration: none;
                        display: inline-flex;
                        align-items: center;
                        gap: 4px;

                        &:hover {
                            color: #111;
                            font-weight: 500;
                        }
                    }

                    /* 3차 항목이 4차 자식을 가질 때: 소그룹 헤더 스타일 */
                    .sub-list-link2--group > a {
                        font-size: 12px;
                        font-weight: 700;
                        color: #555;
                        text-transform: uppercase;
                        letter-spacing: 0.4px;
                        padding-bottom: 3px;
                        border-bottom: 1px solid #e8e8e8;
                        display: block;
                        margin-bottom: 4px;
                        text-decoration: none;

                        &:hover { color: #111; }
                    }

                    /* 4차 메뉴 리스트 */
                    .sub-list-depth4 {
                        margin: 0 0 6px 0;
                        padding: 0;
                        list-style: none;

                        li {
                            margin-bottom: 5px;
                        }

                        .sub-list-link3 > a {
                            font-size: 12px;
                            line-height: 1.4;
                            color: #666;
                            text-decoration: none;
                            display: inline-flex;
                            align-items: center;
                            gap: 4px;
                            padding-left: 8px;

                            &:hover {
                                color: #111;
                                font-weight: 500;
                            }
                        }
                    }
                }
            }
        }

        .right-side {
            display: flex;
            align-items: flex-start;

            & > ul {
                display: flex;
                margin-right: 47px;

                & > li {
                    width: 300px;
                    margin-right: 10px;

                    &:last-of-type {
                        margin-right: 0;
                    }

                    img {
                        width: 100%;
                        display: block;
                        margin-bottom: 10px;
                    }
                    h4 {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 15px;

                        vertical-align: middle;

                        margin: 0;
                        margin-bottom: 6px;
                    }

                    .tag-list {
                        display: flex;
                        align-items: center;
                        margin-bottom: 5px;

                        li {
                            font-size: 12px;
                            line-height: 13px;

                            vertical-align: middle;
                            margin-right: 10px;

                            &:last-of-type {
                                margin-right: 0;
                            }
                        }
                    }

                    a {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 36px;

                        vertical-align: middle;
                        color: #3e7af2;
                    }
                }
            }
            & > div {
                text-align: right;

                p {
                    font-size: 14px;
                    line-height: 130%;

                    color: #1e5e2a;

                    strong {
                        font-weight: 500;
                    }

                    margin: 0 0;
                }

                img {
                    vertical-align: top;
                }

                a {
                    color: #3e7af2;
                }
            }
        }
    }

    .pointer {
        cursor: pointer;
    }

    .headermenu {
        position: relative;
        height: 100%;
    }
    .headermenu .v-list-item {
        /*서브메뉴 위치때문에*/
        position: static;
    }
    .headermenu .v-list-item + .v-list-item {
        margin-left: 35px;
        /**/
    }
    .headermenu .category {
        text-align: center;
        width: 32px;
        margin-left: -5px !important;
        border: 0 none;
        color: #000;
    }
    .headermenu .category a {
        color: #000;
    }
    .v-list-item {
        padding: 0 !important;
    }

    /* 오른쪽 아이콘 스타일 */
    .right-icons {
        margin-top: -2px;
        margin-right: -4px;
    }
    /* .icon-item {} */
    .icon-item a {
        font-size: 2rem;
        line-height: 1;
        display: block;
        text-align: center;
        margin: 0 4px;
        padding: 4px;
    }
    .icon-badge {
        position: absolute;
        top: -20px;
        right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100;
    }
    .icon-floating {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }

    .no-href {
        opacity: 0.4;
    }

    .sub-menu-title {
        font-weight: 500;
        font-size: 16px;
        line-height: 130%;
        color: #000 !important;
    }

    .headermenu {
        .menubar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 100%;
        }
    }

    /* 헤더 인라인 로고 */
    .hm-logo {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin-right: 32px;

        .hm-logo__cat {
            height: 46px;
            width: auto;
            object-fit: contain;
        }
        .hm-logo__bi {
            height: 28px;
            width: auto;
            margin-right: 6px;
        }
        .hm-logo__img {
            height: 46px;
            width: auto;
        }
    }

    /* 1차 메뉴 아이템 배지 */
    .nav-item-label {
        position: relative;
        display: inline-block;
    }
    .nav-badge {
        position: absolute;
        top: -7px;
        right: -28px;
        font-size: 9px;
        font-weight: 700;
        line-height: 1;
        padding: 2px 5px;
        border-radius: 3px;
        letter-spacing: 0.3px;
        color: #fff;
        white-space: nowrap;

        &--new {
            background: #3e7af2;
        }
        &--sale {
            background: #e53935;
        }
        &--hot {
            background: #ff6d00;
        }
    }

    /* 3차 메뉴 HOT 배지 */
    ::v-deep .badge-hot-tag {
        display: inline-flex;
        align-items: center;
        background: #ff6d00;
        color: #fff;
        font-size: 9px;
        font-weight: 700;
        padding: 2px 5px;
        border-radius: 10px;
        line-height: 1.4;
        letter-spacing: 0.3px;
        vertical-align: middle;
        flex-shrink: 0;
    }

    .user-info-bar {
        display: flex;
        align-items: center;
        gap: 2px;
        margin-right: 8px;
        font-size: 13px;
        color: #222;
        white-space: nowrap;

        .user-name {
            font-weight: 600;
        }
        .user-company {
            font-weight: 400;
            color: #666;
        }
    }
</style>
